export default {
    path: 'evalManagement',
    name: 'evalManagementForm',
    component() {
        return import('@/components/evalManagement/EvalManagementForm.vue');
    },
    children: [
        {
            path: '',
            name: 'EvalManagementMaster',
            component() {
                return import('@/components/evalManagement/EvalManagementMaster.vue');
            }
        },
    ],
}